/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { START_SOFTSKILLS_USER_COURSE } from "./actionTypes"
import {
  startSoftskillsUserCourseError,
  startSoftskillsUserCourseSuccess,
} from "./actions"

//Include Both Helper File with needed methods
import { startSoftskillsUserCourse } from "../../../helpers/backend_helper"

function* start(action) {
  try {
    const response = yield call(startSoftskillsUserCourse, action.payload.form)
    if (response == undefined) throw new Error("API error")
    yield put(startSoftskillsUserCourseSuccess(response))
  } catch (error) {
    console.log(error.message)
    yield put(startSoftskillsUserCourseError(error.message))
  }
}

function* softskillsUserCourseStartSaga() {
  yield takeEvery(START_SOFTSKILLS_USER_COURSE, start)
}

export default softskillsUserCourseStartSaga
